const yup = require("yup");

// Schema for createcollegerules
const create = yup.object({
  programme: yup.string().required("Programme group is required"),
  label: yup.string().required("Label is required"),
  status: yup.boolean().required("Status is required"),
  required: yup.boolean().required("Required is required"),
});

module.exports = {
  create,
};
